import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    weeklyLeaders: [],
    monthlyLeaders: [],
    yearlyLeaders: [],
    loading: false,
    error: null,
    timeframe: 'week' // default timeframe
};

const leaderboardSlice = createSlice({
    name: 'leaderboard',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        setWeeklyLeaders: (state, action) => {
            state.weeklyLeaders = action.payload;
        },
        setMonthlyLeaders: (state, action) => {
            state.monthlyLeaders = action.payload;
        },
        setYearlyLeaders: (state, action) => {
            state.yearlyLeaders = action.payload;
        },
        setTimeframe: (state, action) => {
            state.timeframe = action.payload;
        }
    }
});

export const {
    setLoading,
    setError,
    setWeeklyLeaders,
    setMonthlyLeaders,
    setYearlyLeaders,
    setTimeframe
} = leaderboardSlice.actions;

export default leaderboardSlice.reducer; 